import styled from "styled-components";
import {isValidString} from "../../utils";
import {CSSProperties} from "react";

interface FlexProps {
    justify?: CSSProperties['justifyContent'],
    align?: CSSProperties['alignItems'],
}
export const FlexColumn = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: ${(props: FlexProps) => props.hasOwnProperty('justify') && isValidString(props.justify) ? props.justify : 'flex-start'};
  align-items: ${(props: FlexProps) => props.hasOwnProperty('align') && isValidString(props.align) ? props.align : 'normal'};
`;
